const getNavigator = () => {
    if (typeof navigator === "undefined") {
        return null;
    }

    return navigator;
}

export const isIPadOSDesktopMode = (nav = getNavigator()) => {
    return Boolean(
        nav &&
        nav.platform === "MacIntel" &&
        Number(nav.maxTouchPoints || 0) > 1
    );
}

export const isMobileOrTabletUserAgent = (userAgent = "") => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|Tablet|Kindle|Silk|PlayBook/i.test(userAgent);
}

export const isUnsupportedMobileOrTablet = (nav = getNavigator()) => {
    if (!nav) {
        return false;
    }

    return isIPadOSDesktopMode(nav) || isMobileOrTabletUserAgent(nav.userAgent || "");
}
